import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";

import LessonEditDataVideo from "./LessonEditDataVideo";
import LessonEditDataListOrder from "./LessonEditDataListOrder";
import LessonEditDataSelect from "./LessonEditDataSelect";
import LessonEditBox from "./LessonEditDataBox";
import LessonEditDataAudioList from "./LessonEditDataAudioList";
import LessonEditDataDiscoverWord from "./LessonEditDataDiscoverWord";
import LessonEditDataDiscoverSentence from "./LessonEditDataDiscoverSentence";
import LessonEditDataUnion from "./LessonEditDataUnion";
import LessonEditDataUnionWithBox from "./LessonEditDataUnionWithBox";
import clean from "clean-deep";
import { LessonResourcesDownloadHandler } from "./LessonResourcesDownload/LessonResourcesDownloadHandler";

const LessonEdit = ({
  advice: propAdvice = undefined,
  description: propDescription = undefined,
  data = undefined,
  onChange = () => {},
  onCardClick = () => {},
}) => {
  const [advice, setAdvice] = useState(propAdvice);
  const [description, setDescription] = useState(propDescription);

  const [newData, setNewData] = useState(undefined);

  useEffect(() => {
    setAdvice(propAdvice || "");
    setDescription(propDescription || "");
  }, [propAdvice, propDescription]);

  const lessons = {
    LESSON_VIDEO: LessonEditDataVideo,
    LESSON_LIST_ORDER: LessonEditDataListOrder,
    LESSON_SELECT: LessonEditDataSelect,
    LESSON_BOX: LessonEditBox,
    LESSON_AUDIO_LIST: LessonEditDataAudioList,
    LESSON_DISCOVER_WORD: LessonEditDataDiscoverWord,
    LESSON_DISCOVER_SENTENCE: LessonEditDataDiscoverSentence,
    LESSON_UNION: LessonEditDataUnion,
    LESSON_UNION_WITH_BOX: LessonEditDataUnionWithBox,
  };

  const type = getType(data);
  const Lesson = lessons[type];

  const memoizedOnChange = useCallback(
    (state) =>
      onChange(clean({ data: { [type]: state.data }, advice, description })),
    [onChange, type, advice, description]
  );

  const type2 = getType(newData);
  const LessonTwo = lessons[type2];

  const memoizedOnChange2 = useCallback(
    (state) =>
      onChange(clean({ data: { [type2]: state.data }, advice, description })),
    [onChange, type2, advice, description]
  );

  useEffect(() => {
    if (type !== undefined && data !== undefined && type === 'LESSON_RESOURCES_DOWNLOAD') {
      setNewData(data);
    } else setNewData(undefined);
  }, [type, data]);

  return (
    <Container>
      {newData ? (
        <>
          {type2 !== 'LESSON_RESOURCES_DOWNLOAD' && (
            <>
              <BoxType src={`${type2}.jpg`} />

              <Areas>
                <Textarea
                  placeholder="Aviso [VIDEOURL]"
                  value={advice}
                  onChange={(e) => setAdvice(e.target.value)}
                />
                <Textarea
                  placeholder="Descripción"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Areas>
              <LessonTwo data={newData[type2]} onChange={memoizedOnChange2} />
            </>
          )}
          {type2 === 'LESSON_RESOURCES_DOWNLOAD' && (
            <LessonResourcesDownloadHandler data={newData[type2]} onChange={memoizedOnChange2}  />
          )}
        </>
      ) : (
        <>
          {Lesson ? (
            <>
              <BoxType src={`${type}.jpg`} />
              <Areas>
                <Textarea
                  placeholder="Aviso [VIDEOURL]"
                  value={advice}
                  onChange={(e) => setAdvice(e.target.value)}
                />
                <Textarea
                  placeholder="Descripción"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Areas>
              <Lesson data={data[type]} onChange={memoizedOnChange} />
            </>
          ) : (
            <LessonsTypes>
              <BoxType
                src="LESSON_VIDEO.jpg"
                onClick={() => setNewData({ LESSON_VIDEO: "" })}
              />
              <div 
                onClick={() => setNewData({ 
                  LESSON_RESOURCES_DOWNLOAD: {
                  description: "",
                  data: []
                }})}
                className="w-[180px] h-[180px] rounded-[10px] m-[10px] cursor-pointer bg-[#30B0E9] flex items-center justify-center text-white text-center">
                Lección de descargar documentos
              </div>
              <BoxType
                src="LESSON_BOX.jpg"
                onClick={() => setNewData({ LESSON_BOX: [] })}
              />
              <BoxType
                src="LESSON_AUDIO_LIST.jpg"
                onClick={() => setNewData({ LESSON_AUDIO_LIST: [] })}
              />
              <BoxType
                src="LESSON_DISCOVER_SENTENCE.jpg"
                onClick={() => setNewData({ LESSON_DISCOVER_SENTENCE: [] })}
              />
              <BoxType
                src="LESSON_DISCOVER_WORD.jpg"
                onClick={() => setNewData({ LESSON_DISCOVER_WORD: [] })}
              />
              <BoxType
                src="LESSON_LIST_ORDER.jpg"
                onClick={() => setNewData({ LESSON_LIST_ORDER: [] })}
              />
              <BoxType
                src="LESSON_SELECT.jpg"
                onClick={() => setNewData({ LESSON_SELECT: [] })}
              />
              <BoxType
                src="LESSON_UNION_WITH_BOX.jpg"
                onClick={() =>
                  setNewData({ LESSON_UNION_WITH_BOX: { alternatives: [] } })
                }
              />
              <BoxType
                src="LESSON_UNION.jpg"
                onClick={() => setNewData({ LESSON_UNION: [] })}
              />
              <BoxType
                src="LESSON_CARTA.jpg"
                onClick={() => onCardClick("LESSON_CARTA")}
              />
            </LessonsTypes>
          )}
        </>
      )}
    </Container>
  );
};

const getType = (data) => Object.keys(data || {})[0];

const LessonsTypes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

const BoxType = styled.img`
  width: 180px;
  height: 180px;
  object-fit: cover;
  background-color: black;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px;
`;

const Areas = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

const Textarea = styled.textarea`
  height: 100px;
  flex: 1;
  margin: 5px;
  border: 1px solid #bdbdbd;
  border-radius: 10px;
  padding: 10px;
  outline: 0;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export default LessonEdit;
